import { render } from "./SidebarMenuItem.vue?vue&type=template&id=a7e90c96&ts=true"
import script from "./SidebarMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarMenuItem.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarMenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a7e90c96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a7e90c96', __exports__)) {
    api.reload('a7e90c96', __exports__)
  }
  
  module.hot.accept("./SidebarMenuItem.vue?vue&type=template&id=a7e90c96&ts=true", () => {
    api.rerender('a7e90c96', render)
  })

}


export default __exports__